import React from "react";
import {
  HeroSection,
  FeatureSection,
  CoachesSection,
  IntegrationSection,
  SportsSection,
  PriceSection,
  ActivitySection,
  TestimonialSection,
  NewsletterSection,
} from "./index";

// Services
import userService from "../../../services/user.service";
class Home extends React.Component {
  state = {
    taglineDetailsResponses: [],
    softwareStrengthsDetails: [],
    features: [],
    testimonialContent: [],
    sportsContent: [],
    integrationContent: [],
    premiumContent: [],
  };

  componentDidMount() {
    this.getAllTagline();
    this.getAllIntegration();
    this.getAllFeatures();
    this.getPremiumWeek();
    this.getAllSportsAnalysis();
    this.getAllTestimonials();
    this.getAllSoftwareStrengths();
  }

  getAllSoftwareStrengths() {
    userService.getSoftwareStrengths().then((res) => {
      this.setState({
        softwareStrengthsDetails:
          res.data.data.softwareStrengthsDetailsResponses,
      });
    });
  }

  getAllTagline() {
    userService.getAllTagline().then((res) => {
      var taglineDetailsResponses = res.data.data.taglineDetailsResponses;
      this.setState({ taglineDetailsResponses });
    });
  }

  getAllIntegration() {
    userService.getAllIntegration().then((res) => {
      this.setState({
        integrationContent: res?.data?.data?.integratedDetailsResponses || [],
      });
    });
  }

  getAllSportsAnalysis() {
    userService.getSportsAnalysis().then((res) => {
      this.setState({
        sportsContent: res?.data?.data?.sportsAnalysisDetailsResponses || [],
      });
    });
  }

  getAllTestimonials() {
    userService.getTestimonials().then((res) => {
      this.setState({
        testimonialContent: res?.data?.data?.testimonialsDetailsResponses || [],
      });
    });
  }

  getAllFeatures() {
    let features = [];
    const dataArray = [
      "presentations",
      "analysis",
      "kpi",
      "review",
      "dataImports",
      "capture",
    ];
    userService.getAllFeatures().then((res) => {
      const {
        data: {
          data: { featuresDetailsResponses },
        },
      } = res;
      dataArray.forEach((item) => {
        features.push(featuresDetailsResponses[0][item]);
      });
      features.unshift("Setup your teams");
      this.setState({ features });
    });
  }

  getPremiumWeek() {
    userService.getAllPremiumWeeks().then((res) => {
      this.setState({
        premiumContent: res?.data?.data?.weeksDetailsResponses || [],
      });
    });
  }

  render() {
    const {
      taglineDetailsResponses,
      softwareStrengthsDetails,
      features,
      testimonialContent,
      sportsContent,
      integrationContent,
      premiumContent,
    } = this.state;
    return (
      <div className="Home">
        <HeroSection payload={taglineDetailsResponses} />
        <FeatureSection payload={features} />
        <CoachesSection />
        <IntegrationSection payload={integrationContent} />
        <SportsSection payload={sportsContent} />
        <PriceSection payload={premiumContent} />
        <ActivitySection payload={softwareStrengthsDetails} />
        <TestimonialSection />
        <NewsletterSection />
      </div>
    );
  }
}

export default Home;
